import { getCouponInfo, setCouponInfo, removeCouponInfo } from '@/utils/coupon.js'

const COUPON_INFO = 'couponInfo'

let getDefaultState = () => ({
  couponInfo: getCouponInfo()
})

let state = getDefaultState()

let mutations = {
  [COUPON_INFO]: (state, info) => {
    state.couponInfo = info
  }
}

let actions = {
  setCouponInfo({ commit }, info) {
    setCouponInfo(info)
    commit(COUPON_INFO, info)
  },

  removeCouponInfo() {
    removeCouponInfo()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
